import Actions from '../actions/actions';
import { setBusy, setUnBusy } from './common/commonReducers';
import { SendlaneListsResponse, SendlaneModel } from '../model/SendlaneModel';
import SendlaneCRUDActions from '../actions/SendlaneCRUDActions';

type ActionType = {
  type: string;
  lists: SendlaneListsResponse[];
};

const initialState: SendlaneModel = {
  busy: false,
  lists: [],
};

export const sendlane = (state = initialState, action: ActionType) => {
  switch (action.type) {
    case SendlaneCRUDActions.busyAction:
      return setBusy(state);

    case SendlaneCRUDActions.retrieveLists: {
      return {
        ...state,
        lists: action.lists,
        busy: false,
      };
    }
    case Actions.UNBUSY:
      return setUnBusy(state);
    default:
      return state;
  }
};
